jQuery(document).ready(function () {

});
NHS.Scripts.GooglePropertyMap = function (parameters) {
  this.parameters = parameters;
  this.isMapCreate = false;
  this.alreadyClicked = false;
  this.reDrawMap = true;
  this.disableShowButton = parameters.disableShowButton;
};

NHS.Scripts.GooglePropertyMap.prototype =
  {
    InitMap: function () {
      var self = this;
      var mapOptions = self.parameters.OptionsForMap;

      let salesOfficeTab = document.querySelector('[data-type="sales-office"]');
      let coordinatesElement = document.querySelector('#nhs_MapTabs [data-active]');

      if(salesOfficeTab && coordinatesElement){
        mapOptions.MapOptions.Latitude = Number(coordinatesElement.dataset.lat);
        mapOptions.MapOptions.Longitude = Number(coordinatesElement.dataset.lng);
      }

      self.isMapCreate = true;
      self.googleApi.createMap();
      self.googleApi.createMarkerPoint(mapOptions.MapOptions.Latitude, mapOptions.MapOptions.Longitude, null, null, self.parameters.icon, null, null, null, mapOptions.MapOptions.label);

      if (self.parameters.NearbyComms) {
        self.googleApi.processResult(self.parameters.NearbyComms);
      }

      self.mapExpanded();
      if (!self.disableShowButton) {
        self.SetUpdate();
      }
      if (!self.googleApi.map) {
        return;
      }
      google.maps.event.addListener(self.googleApi.map, 'idle', self.RemoveGoogleInfo);
      jQuery.HideLoading();
      if (typeof self.googleApi.initializeAutoComplete === 'function') {
        self.googleApi.initializeAutoComplete();
      }
    },

    CreateMap: function () {
      var self = this;
      if (self.isMapCreate) {
        if (self.parameters.isBasicListing) {
          self.parameters.logger.logBasicListingEvent('BLMAPV', self.parameters.communityId);
        }
        if (jQuery('#tabBuilderMap a').length > 0 && self.reDrawMap) {
          self.reDrawMap = false;
          self.googleApi.ReDrawMap();
        }
      }

      if (!self.isMapCreate) {
        if (jQuery("#nhs_GoogleMapScript").length === 0) {
          NHS.Scripts.GoogleMapApi.prototype.loadGoogleMapsCode(self.parameters.googleMapScript +
            '&callback=initializeDP');
        } else {
          self.googleApi.WaitGoogleScript(function () {
            self.InitMap();
          }, 100, self.googleApi);
        }
      }
      dataLayer.push({ "mapCoordinates": "o|" + self.parameters.OptionsForMap.MapOptions.Latitude + "|" + self.parameters.OptionsForMap.MapOptions.Longitude });
    },

    SetUpGoogleApi: function () {

      var self = this;
      var parameters = self.parameters;

      var mapOptions = this.parameters.OptionsForMap;
      var googleApi = new NHS.Scripts.GoogleMapApi(mapOptions);

      googleApi.getIconMarkerPoint = function (results, result) {
        if (result.MarketPoints.length > 1)
          return parameters.iconNearByCommMulti;
        return parameters.iconNearByComm;
      };

      googleApi.options.Events.MarkerClickCallBack = function (info, infowindow, infowindowTooltip, marker) {
        if (info && info.MarketPoints) {
          var commIds = [];
          for (var i = 0; i < info.MarketPoints.length; i++) {
            commIds.push(info.MarketPoints[i]['CommunityId'] + "|" + 0);
          }

          jQuery.ajax({
            url: parameters.getCommunityMapCards,
            type: "GET",
            data: {
              commIds: commIds.join(),
              basicIds: ""
            },
            success: function (html) {
              if (html) {
                infowindow.setContent(html);
                infowindow.open(googleApi.map, marker);
              }
            }
          });
        }
      };

      googleApi.placeChangedProcess = function (marker, autocomplete) {
        var place = autocomplete.getPlace();
        self.location = place.geometry.location;
      };

      return googleApi;
    },

    init: function () {
      var self = this;
      var parameters = self.parameters;
      self.googleApi = self.SetUpGoogleApi();
      jQuery('#dd-collapsible').hide();
      jQuery('#nhs_propertyMapCollapsibleClose').hide();

      var newMapsContainer = document.querySelectorAll("#nhs_MapsAndDirections");
      if (newMapsContainer) {
        self.CreateMap();
      }

      if (parameters.isGalleryXp) {
        jQuery("#nhs_propertyMapCollapsibleOpen").click(function () {
          self.googleApi.loadGoogleMapsCode(self.parameters.googleMapScript);
          var mapContainer = document.getElementById("nhs_PropertyMap");
          if (mapContainer.children.length > 0) return;
          self.getPropertyMapSides(self, false);
          self.reDrawMap = false;
        });
      }

      jQuery('#nhs_propertyMapCollapsibleOpen, #nhs_mapTab').click(function (event) {
        if (parameters.isGalleryXp !== true) {
          self.getPropertyMapSides(self, window.location.pathname.indexOf("preview") > 0);
        }

        self.parameters.logger.logEventWithParameters("Drive_Dir_Reveal", self.parameters.logInfo);
        if (jQuery("#dd-collapsible").css('display') === 'none') {
          jQuery('#dd-collapsible').show();
          if (self.parameters.isGalleryXp === true && self.reDrawMap && self.isMapCreate) {
            self.reDrawMap = false;
            self.googleApi.ReDrawMap();
          }
        }
        jQuery('#nhs_propertyMapCollapsibleOpen').hide();
        jQuery('#nhs_propertyMapCollapsibleClose').show();

        NHS.loadCss(document.getElementById("detailsXpMapCss").value);
      });

      jQuery('#nhs_propertyMapCollapsibleClose').click(function (event) {
        jQuery('#dd-collapsible').hide();
        jQuery('#nhs_propertyMapCollapsibleClose').hide();
        jQuery('#nhs_propertyMapCollapsibleOpen').show();
      });

      self.InitDrivingDirection();
    },

    getPropertyMapSides: function (self, isPreview) {
      var parameters = self.parameters;
      var isMpc = (typeof parameters.isMPCommunity != 'undefined') ? parameters.isMPCommunity : false;
      if (typeof parameters.GetPropertyMapRightSide != 'undefined') {
        jQuery.ajax({
          url: parameters.GetPropertyMapRightSide,
          data: {
            "communityId": parameters.communityId,
            "isMPC": isMpc,
            "isPreview": isPreview
          },
          type: "POST",
          success: function (data) {
            jQuery("#nhs_MapRightSide").html(data);
            jQuery('#nhs_PropertyMap').width(parameters.mapWidth).height(parameters.mapHeight);
            if (jQuery("#nhs_mapTypeMenu")) {
              self.isMapCreate = false;
              var buildderTabMap = jQuery('#tabBuilderMap');
              buildderTabMap.click();
              self.CreateMap();
            }
          }
        });
      } else {
        jQuery('#nhs_PropertyMap').width(parameters.mapWidth).height(parameters.mapHeight);
        self.CreateMap();
      }
    },

    mapExpanded: function () {
      var self = this;

      if (!this.alreadyClicked) {

        if (self.parameters.isBasicCommunity) {
          self.parameters.logger.logMultiEvent('bcMapSectionReveal', self.parameters.communityId, self.parameters.builderId, 0, 0);
          jQuery.googlepush('Basic Listing', 'Driving Directions', self.parameters.communityId, 2, false);
        }

        this.alreadyClicked = true;
      }
    },

    InitDrivingDirection: function () {
      var self = this;
      jQuery('#nhs_drivingDirections').show();

      jQuery('#nhs_CommMapTab1').addClass("nhs_Active");

      jQuery('#nhs_CommMapTabs a').click(function () {
        if (jQuery(this).is('.GoogleMap') && jQuery('#nhs_CommunityMapTab').is(':visible')) {
          self.parameters.logger.logEventWithParameters("Drive_Dir_Reveal", self.parameters.logInfo);

          jQuery('#nhs_CommunityMapTab').toggle();
          jQuery('#nhs_GoogleMapTab').toggle();
          jQuery('#nhs_CommMapTab1').removeClass("nhs_Active");
          jQuery('#nhs_CommMapTab2').addClass("nhs_Active");
          self.CreateMap();

          var $buildderTabMap = jQuery('#tabBuilderMap a');
          if ($buildderTabMap.length > 0) {
            self.isMapCreate = false;
            $buildderTabMap.click();
          }
        } else if (jQuery(this).is('.CommMap') && jQuery('#nhs_GoogleMapTab').is(':visible')) {
          jQuery('#nhs_CommunityMapTab').toggle();
          jQuery('#nhs_GoogleMapTab').toggle();
          jQuery('#nhs_CommMapTab2').removeClass("nhs_Active");
          jQuery('#nhs_CommMapTab1').addClass("nhs_Active");
        }

        return false;
      });

      jQuery('#Maps').on("click", "#tabMQMap", function () {
        if (!jQuery('#nhs_PropertyMap').is(':visible')) {
          jQuery('#nhs_PropertyMap').toggle();
          jQuery('#tabBuilderMap').find('a').toggleClass('On');
          jQuery('#tabMQMap').find('a').toggleClass('On');
          jQuery('#nhs_BuilderPropertyMap').toggle();
          jQuery('#nhs_drivingDirections').hide();
          jQuery('#nhs_GetDirections').show();
          jQuery('#nhs_drivingDirections').show();
        }
        self.CreateMap();

        return false;
      }
      );

      jQuery('#Maps').on("click", "#tabBuilderMap", function () {

        if (!jQuery('#nhs_BuilderPropertyMap').is(':visible')) {
          jQuery('#nhs_BuilderPropertyMap').toggle();
          jQuery('#tabBuilderMap').find('a').toggleClass('On');
          jQuery('#tabMQMap').find('a').toggleClass('On');
          jQuery('#nhs_PropertyMap').toggle();
          jQuery('#nhs_drivingDirections').show();
          jQuery('#nhs_GetDirections').hide();
          jQuery('#nhs_drivingDirections').show();
        }

        var alreadyBuilderMapClicked = NHS.Scripts.Helper.readCookie('drivingDirectionsBuilderMapClicked');

        if (!alreadyBuilderMapClicked) {
          if (!self.parameters.isBasicListing || !self.parameters.isBasicCommunity) {
            if (self.parameters.specId > 0 || self.parameters.planId > 0) {
              self.parameters.logger.logEventWithParameters('HDSDD', self.parameters.logInfo);
            } else {
              self.parameters.logger.logEventWithParameters('CDSDD', self.parameters.logInfo);
            }
          }

          NHS.Scripts.Helper.createCookie('drivingDirectionsBuilderMapClicked', 1, 0);
        }

        return false;
      });
      var date = new Date();
      date.setDate(date.getDate() + 1);
      var currentMonth = date.getMonth();
      var currentDate = date.getDate();
      var currentYear = date.getFullYear();
      jQuery("#nhsTxtDate").datepicker({
        minDate: new Date(currentYear, currentMonth, currentDate)
      });
      jQuery("#nhsTxtDate").attr("disabled", "disabled");
      jQuery('.nhs_PickerIconContainer').click(function () {
        jQuery('#nhsTxtDate').datepicker("show");
        initDatepickerGallery();
      });
      jQuery(".btn_NhsMapSend").mousedown(function () {
        window.NewHomeSource.ModalLoader.initTrigger('.btn_NhsMapSend',
          function () {
            var dateValue = jQuery("#nhsTxtDate").datepicker('getDate');
            setTimeout(function () {
              if (dateValue != null) {
                var actualDate = new Date(dateValue);
                jQuery("#RequestBrochureDate").datepicker({
                  minDate: new Date(currentYear, currentMonth, currentDate)
                }).datepicker("setDate", actualDate);
              } else {
                jQuery("#RequestBrochureDate").datepicker({
                  minDate: new Date(currentYear, currentMonth, currentDate)
                });
              }
              jQuery("#RequestBrochureDate").attr("disabled", "disabled");
              jQuery('.nhs_PickerIconModal').click(function () {
                jQuery('#RequestBrochureDate').datepicker("show");
                initDatepickerGallery();
              });
            }, 1000);
          });
      });
  },

    /**
     * TrackShowRouteEvents: tracks the events for the show routes button.
     */
    TrackShowRouteEvents: function () {
      const routeInput = document.querySelector('[data-map-route-input]');
      const routeInputText = routeInput.value;

      const event = {
        eventType: 'GA4Event',
        eventName: 'driving_routes',
        params: {
          click_target: 'show route',
          event_type: 'TDV Events',
          search_value: routeInputText,
          currency: 'USD',
          value: 10
        }
      }

      document.body.dispatchEvent(new CustomEvent('trackOnDemandEvent', {
        detail: { data: event }
      }));
    },

    SetUpdate: function () {
      var self = this;
      jQuery('#btnUpdate').click(function () {
        const inputWrapper = document.querySelector('[data-direction-wrapper-input]');
        if (self.parameters.isBasicCommunity) {
          self.parameters.logger.logMultiEvent('bcRoute', self.parameters.communityId, self.parameters.builderId, self.parameters.planId, self.parameters.specId);
          jQuery.googlepush('Basic Listing', 'Driving Route', self.parameters.communityId, 4, false);
        }

        var address = jQuery("#nhsTxtStreeAddress").val();

        if (address) {
          jQuery('#nhsWrongAddress').hide();
          inputWrapper.classList.remove('nhs-c-input__wrapper--error');
        }
        if (self.location && address && address.trim() !== "") {
          var left = (screen.width - 840) / 2;
          var top = (screen.height - 600) / 2;
          jQuery('#nhsWrongAddress').hide();
          inputWrapper.classList.remove('nhs-c-input__wrapper--error');
          //self.parameters
          var url = self.parameters.drivingDirectionAction + '?communityId=' + self.parameters.communityId +
            "&lat=" + self.location.lat() + "&lng=" + self.location.lng() + '&check=false' + '&isBasicListing=' + self.parameters.isBasicListing + '&startingPoint=' + address;
          jQuery.SetDataLayerPair('siteDrivingRoute');
          self.TrackShowRouteEvents();
          window.open(url, '_blank', 'width=840,height=600,top=' + top + ',left=' + left + ',menubar=yes,status=no,location=no,toolbar=no,scrollbars=yes');
        } else {
          if (address && address.trim() !== "") {
            let eventForTdv = {
              builder: self.parameters.builderId,
              community: self.parameters.communityId.toString(),
              market: self.parameters.marketId,
              label: 'Drive_Route_Req',
              eventType: 'tdvEvent'
            };
            document.body.dispatchEvent && document.body.dispatchEvent(new CustomEvent("trackOnDemandEvent", {
              detail: { data: eventForTdv }
            }));
            var geocoder = new google.maps.Geocoder();
            geocoder.geocode({ 'address': address }, function (results, status) {
              if (status == google.maps.GeocoderStatus.OK) {
                var url = self.parameters.drivingDirectionAction + '?communityId=' + self.parameters.communityId +
                  "&lat=" + results[0].geometry.location.lat()
                  + "&lng=" + results[0].geometry.location.lng() + '&check=false' + '&isBasicListing=' + self.parameters.isBasicListing + '&startingPoint=' + address;
                jQuery.SetDataLayerPair('siteDrivingRoute');
                self.TrackShowRouteEvents();
                window.open(url, '_blank', 'width=840,height=600,top=' + top + ',left=' + left + ',menubar=yes,status=no,location=no,toolbar=no,scrollbars=yes');
              } else {
                jQuery('#nhsWrongAddress').show();
                inputWrapper.classList.add('nhs-c-input__wrapper--error');
              }
            });
          } else {
            jQuery('#nhsWrongAddress').show();
            inputWrapper.classList.add('nhs-c-input__wrapper--error');
          }
        }
      });
    },

    RemoveGoogleInfo: function () {
      if (jQuery(".gm-style > div > a").attr("href")) {
        var aux;
        var len = jQuery('.gm-style-cc').length;
        for (aux = 1; aux < len; aux += 1) {
          jQuery('.gm-style-cc').eq('-1').remove();
        }
        jQuery(".gm-style > div > a").removeAttr("href").removeAttr("title");
      }
    }
  };
